import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface AITranslatorConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const AITranslatorConfig: React.FC<AITranslatorConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="AI Fordító">
        <ConfigField
          label="Fordítandó szöveg"
          description="A szöveg amit le kell fordítani"
        >
          <textarea
            value={node.data.config?.text || ''}
            onChange={(e) => updateConfig('text', e.target.value)}
            placeholder="{{message}} vagy közvetlen szöveg..."
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <div className="grid grid-cols-2 gap-3">
          <ConfigField
            label="Forrás nyelv"
            description="Eredeti nyelv"
          >
            <select
              value={node.data.config?.sourceLang || 'auto'}
              onChange={(e) => updateConfig('sourceLang', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            >
              <option value="auto">Automatikus</option>
              <option value="hu">Magyar</option>
              <option value="en">Angol</option>
              <option value="de">Német</option>
              <option value="fr">Francia</option>
              <option value="es">Spanyol</option>
              <option value="it">Olasz</option>
            </select>
          </ConfigField>

          <ConfigField
            label="Cél nyelv"
            description="Fordítás nyelve"
          >
            <select
              value={node.data.config?.targetLang || 'en'}
              onChange={(e) => updateConfig('targetLang', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            >
              <option value="hu">Magyar</option>
              <option value="en">Angol</option>
              <option value="de">Német</option>
              <option value="fr">Francia</option>
              <option value="es">Spanyol</option>
              <option value="it">Olasz</option>
            </select>
          </ConfigField>
        </div>

        <ConfigField
          label="AI Provider"
          description="Fordítási szolgáltatás"
        >
          <select
            value={node.data.config?.provider || 'openai'}
            onChange={(e) => updateConfig('provider', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="openai">OpenAI</option>
            <option value="claude">Claude</option>
            <option value="gemini">Gemini</option>
            <option value="deepl">DeepL</option>
          </select>
        </ConfigField>

        <ConfigField
          label="API Kulcs"
          description="Fordítási szolgáltatás API kulcsa"
        >
          <input
            type="password"
            value={node.data.config?.apiKey || ''}
            onChange={(e) => updateConfig('apiKey', e.target.value)}
            placeholder="API kulcs..."
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="preserveFormatting"
            checked={node.data.config?.preserveFormatting !== false}
            onChange={(e) => updateConfig('preserveFormatting', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="preserveFormatting" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Formázás megtartása
          </label>
        </div>
      </ConfigSection>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3">
        <div className="text-xs text-blue-700 dark:text-blue-300">
          <strong>🌍 AI Fordítás:</strong>
          <br />• Automatikus nyelvfelismerés
          <br />• Eredmény: <code>{'{{translated_text}}'}</code>
          <br />• Felismert nyelv: <code>{'{{source_language}}'}</code>
        </div>
      </div>
    </div>
  );
};

export default AITranslatorConfig;
